import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useRecommendedTemplates } from '../hooks';
import { templateLanguageFor } from '../language';
import { RecommendedTemplateRow } from './RecommendedTemplateRow';

interface TemplateSuggestionsProps {
  /** Heading when the picks come from the org's onboarding answers. */
  title: string;
  /** Heading when there were no usable answers (featured/popular fallback). */
  fallbackTitle: string;
  className?: string;
}

/** Recommended templates that open in the gallery preview. Renders nothing until there is something to show. */
export function TemplateSuggestions({ title, fallbackTitle, className }: TemplateSuggestionsProps) {
  const { i18n } = useTranslation();
  const navigate = useNavigate();
  const { data } = useRecommendedTemplates({ language: templateLanguageFor(i18n.language), limit: 3 });
  if (!data?.data.length) return null;
  const heading = data.basedOnProfile ? title : fallbackTitle;
  return (
    <section aria-label={heading} className={className}>
      <h2 className="mb-2.5 text-sm font-semibold text-foreground">{heading}</h2>
      <RecommendedTemplateRow
        templates={data.data}
        onSelect={(template) => navigate(`/app/tests/templates?preview=${encodeURIComponent(template.id)}`)}
      />
    </section>
  );
}
